import React from 'react'
import styles from '../component/custom.module.css';
import Images from './Images';
import Modal from "react-modal";
import { useState } from "react";
import ShareSocial from './RSSUsage';


const BusinessSection = ({executeScroll}) => {

// modal
const [modalIsOpen, setIsOpen] = useState(false);
function openModal() {
  setIsOpen(true);
}
function closeModal() {
  setIsOpen(false);
}
// Modal

    return (
    <section className={styles.BusinessSection}>
        <div className='container'>
            <div className={styles.BusinessSectionInner}>
                <div className={styles.BusinessSectionLeft}>
                    <img src={Images.MidComIcon2} />
                    <p>Have a small business that you want to <br/>expand? Have a ready product but don’t have  <br/>the funds to market it? </p>
                    <button className={styles.commonBtn} data-event-id="register" onClick={executeScroll} >register now!</button>
                </div>
                <div className={styles.BusinessSectionRight}>
                    <img src={Images.MidComIcon} />
                    <p>Have someone you know who has wonderful <br/> small business but can’t grow due to lack of <br/>resources? </p>
                    {/* <button onClick={openModal} className={styles.commonBtn}>forward now!</button> */}
                    <ShareSocial/>
                </div>
            </div>
            <Modal
                style={{
                content: {
                    display: "flex",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    borderWidth: 0,
                    flexDirection: "column",
                    flex: 1,
                    position: "unset",
                    height: "100%",
                    overflow: "auto",
                    justifyContent: "center",
                },
                }}
                // overlayClassName={Modalstyle.modal}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className="container">
                    <div className={`${styles.modalSocialShare}  bg-white p-4`}>
                        <img className={`${styles.modalClose}`} src={Images.Cancel} onClick={closeModal}  />
                        <h2>Social Share</h2>
                        <ShareSocial/>
                    </div>
                </div>
            </Modal>
        </div>
    </section>
    
    );
  };
  
  export default BusinessSection;

